/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ScreenAPI {

  /**
   * Method that returns all screens
   * @param id
   * @param sspId
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiScreenList(
    id: Array<string>,
    sspId: Array<number>,
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
  ): CancelablePromise<Array<{
    device_id: string;
    ssp_id: number;
    date: string;
    allow_image: boolean;
    allow_video: boolean;
    country: string | null;
    region: string | null;
    city: string | null;
    publisher_id: string;
    postal_code: string;
    screen_id: string;
    screen_name: string;
    formats: string;
    longitude: number;
    latitude: number;
    venue_type_ids: string;
    temperature: number | null;
    weather_ids: string | null;
    city_shape_id: number | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/screen/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'ssp_id': sspId,
      },
    });
  }

  /**
   * Method that returns a particular screen
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiScreen(
    id: string,
  ): CancelablePromise<{
    device_id: string;
    ssp_id: number;
    date: string;
    allow_image: boolean;
    allow_video: boolean;
    country: string | null;
    region: string | null;
    city: string | null;
    publisher_id: string;
    postal_code: string;
    screen_id: string;
    screen_name: string;
    formats: string;
    longitude: number;
    latitude: number;
    venue_type_ids: string;
    temperature: number | null;
    weather_ids: string | null;
    city_shape_id: number | null;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/screen/{id}',
      path: {
        'id': id,
      },
    });
  }

}
